const t =  require('@/lang/index.js').default.global.t

// 国家地区为空校验
export function validateCountry(rule, value, callback){
    if (value === "") {
        callback(new Error('Please enter Country/Region'))
    } else {
        callback()
    }
}

//校验手机号
export function validateMobile(rule, value, callback) {
    if (value === "") {
        callback(new Error(t("verificationTips.telEmptyTips")))
    } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error(t("verificationTips.telErrorTips")))
    } else {
        callback()
    }
}
//校验身份证号
export function validateUserCode(rule, value, callback) {
    if (value === "") {
        callback(new Error('身份证号不能为空'))
    } else if (!/^\d{17}[\dXx]$/.test(value)) {
        callback(new Error('身份证号格式不对'))
    } else {
        callback()
    }
}
//校验社会信用代码
export function validateCreditCode(rule, value, callback) {
    if (value === "") {
        callback(new Error('社会信用代码不能为空'))
    } else if (!/^[0-9A-HJ-NPQRTUWXY]{18}$/.test(value)) {
        callback(new Error('社会信用代码格式不对'))
    } else {
        callback()
    }
}
//校验SN码
export function validateSNCode(rule, value, callback) {
    value = value.trim()
    if (value === "") {
        callback(new Error(t("verificationTips.snCodeEmptyTips")))
    } else if (!/^[a-zA-Z0-9/]+$/.test(value)) {
        callback(new Error(t("verificationTips.snCodeErrorTips")))
    } else {
        callback()
    }
}
//校验姓名
export function validateUserName(rule, value, callback) {
    value = normalizeValue(value)
    console.log('<'+value+'>')
    if (value === "") {
        callback(new Error(t("verificationTips.nameEmptyTips")))
    } else if (!/^.{1,20}$/.test(value)) {
        callback(new Error(t("verificationTips.nameErrorTips")))
    } else {
        callback()
    }
}
//校验企业名称
export function validateEnterName(rule, value, callback) {
    value = normalizeValue(value)
    if (value === "") {
        callback(new Error(t("verificationTips.coNameEmptyTips")))
    } else if (!/^.{1,30}$/.test(value)) {
        callback(new Error(t("verificationTips.coNameErrorTips")))
    } else {
        callback()
    }
}
//校验验证码
export function validateCode(rule, value, callback) {
    if (value === "") {
        callback(new Error(t("verificationTips.yzmEmptyTips")))
    } else if (!/^\d{6}$/.test(value)) {
        callback(new Error(t("verificationTips.yzmErrorTips")))
    } else {
        callback()
    }
}
//校验邮箱
export function validateEmail(rule, value, callback) {
    if (value === "") {
        callback(new Error(t("verificationTips.emailEmptyTips")))
    } else if (!/^[^\s]+@[^\s]+$/.test(value)) {
        callback(new Error(t("verificationTips.emailErrorTips")))
    } else {
        callback()
    }
}
// 校验手机号/邮箱
export function validateMobileOrEmail(rule, value, callback) {
    const mobileReg = /^1[3-9]\d{9}$/;  
    const emailReg = /^[^\s]+@[^\s]+$/;
    if (value === "") {
        callback(new Error(t("verificationTips.accountEmptyTips")))
    } else if (!mobileReg.test(value) && !emailReg.test(value)) {
        callback(new Error(t("verificationTips.accountErrorTips")))
    } else {
        callback()
    }
}
//校验密码
export function validatePassword(rule, value, callback) {
    if (value === "") {
        callback(new Error(t("verificationTips.pswEmptyTips")))
        // /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/ 至少包含一个数字和字母
        // /^[a-zA-Z0-9]{6,20}$/ 包含数字或者字母20位
        //原始校验规则： !/^[a-zA-Z\d]{6,20}$/.test(value)
    } else if (!/^\S{6,20}$/.test(value)) {
        callback(new Error(t("verificationTips.pswErrorTips")))
    } else if (/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(value)) {
        // 不允许汉字（包含常见 CJK 汉字范围）
        callback(new Error(t("verificationTips.pswErrorTips")))
    } else {
        callback()
    }
}

//处理时间 2023-06-19 14:25:47格式 处理成 格式2023_06_19 
export function handledate(dataString) {
    if (!dataString) return
    return dataString.replace(/-/g, '-').split(' ')[0]
}
//处理时间 2023-06-19 14:25:47格式 处理成 格式2023.06.19 
export function handledatepot(dataString) {
    if (!dataString) return
    return dataString.replace(/-/g, '-').split(' ')[0]
}
//处理时间 2023-06-19 14:25:47格式 处理成 格式2023.06.19 
export function handledate1(dateString) {
    // 输入的日期字符串
    // 创建 Date 对象
    const date = new Date(dateString);
    // 获取月份和日期
    const month = date.getMonth() + 1; // 月份从 0 开始，所以需要加 1
    const day = date.getDate();
    return `${month.toString().padStart(2, "0")}/${day.toString().padStart(2, "0")}`
}
//防抖函数
export function debounce(func, wait) {  
    let timeout;  
    return function () {  
      const context = this;  
      const args = arguments;  
      clearTimeout(timeout);  
      timeout = setTimeout(function () {  
        func.apply(context, args);  
      }, wait);  
    };  
  }
  // 节流函数
export function throttle(func, delay){
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall >= delay) {
        lastCall = now;
        func.apply(this, args);
        }
    };
}
  //金额按照千分位用逗号分割
  export function formatNumber(num) {  
    if((!num)&&(num!==0)) return
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')  
} 
//判断对象的属性值是否都为空
export function checkObjectNotEmpty(obj) {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          if (Array.isArray(value) && value.length === 0) {
          return false;
          }
          if (!value) {
          return false;
          }
        }
        }
        return true;
  }
/** 判断是否为 Email（支持中文邮箱） */
export const isEmail = (rule,email,callback) => {
    // const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    const reg = /^[^@].*@.*[^@]$/;
    if (email === "") {
        callback(new Error('邮箱不能为空'))
        // /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/ 至少包含一个数字和字母
        // /^[a-zA-Z0-9]{6,20}$/ 包含数字或者字母20位
    } else if (!reg.test(email)) {
        callback(new Error('邮箱格式不正确'))
    } else {
        callback()
    }
  }


// 新增：规范化输入，去除前后空格，非字符串返回空字符串
export const normalizeValue = (val) => {
  if (val === null || val === undefined) return ''
  if (typeof val === 'string') return val.trim()
  // 若是数字等其它类型，转为字符串再 trim（按需）
  return String(val).trim()
}

// 隐藏手机号
export const hidePhone = (phone) => {
    if(phone) {
        return phone.replace(/(\d{3})\d{5}(\d{3})/, '$1*****$2')
    }
}
